import { ElementRef, forwardRef, useId } from 'react';
import { twMerge } from 'tailwind-merge';
import { inputBase, inputReadOnlyBase } from '../base';
import { type InputFieldProps } from '../types';

const textarea = 'min-h-[120px] max-h-[400px]';

type TextareaElement = ElementRef<'textarea'>;
export type TextareaFieldProps = React.HTMLProps<HTMLTextAreaElement> &
  Omit<InputFieldProps, 'size'> &
  InputFieldProps & {
    name: string;
    id?: string;
    onChange?: (value: string) => void;
  };

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const TextareaField = forwardRef<TextareaElement, TextareaFieldProps>(
  (
    { id, name, intent, value, disabled, placeholder, onChange, ...restProps },
    forwardedRef,
  ) => {
    const generatedId = useId();
    const textareaStyles = twMerge(
      inputBase({ intent }),
      inputReadOnlyBase,
      textarea,
    );

    return (
      <textarea
        {...restProps}
        name={name}
        id={id || generatedId}
        ref={forwardedRef}
        aria-disabled={disabled}
        aria-invalid={intent === 'error'}
        className={textareaStyles}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(event) => onChange && onChange(event.target.value)}
        value={value}
      />
    );
  },
);

TextareaField.displayName = 'TextareaField';
